<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Organograma
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome da Gerência*"
                  maxlength="40"
                  counter="40"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="content.sigla"
                  label="Sigla da Gerência*"
                  maxlength="12"
                  counter="12"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-text-field>
              </v-col>
              <v-col cols="9">
                <v-select
                  v-model="content.secretariaExecutiva"
                  :items="form.lists.secretarias"
                  :item-text="'nome'"
                  :item-value="'identificador'"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  label="Secretaria Executiva*"
                  return-object
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="content.setores"
                  label="Setor(es)*"
                  :items="form.lists.setores"
                  :item-text="'nome'"
                  :item-value="'id'"
                  :rules="[(v) => v && v.length > 0 || 'Campo obrigatório']"
                  return-object
                  outlined
                  multiple
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'">
        </sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Organograma } from "~/commons/classes/organograma";
import ManterOrganogramaService from "@/services/manter-organograma.service";
import ManterSetorService from "~/services/manter-setor.service";
import OrigemEnum from '~/commons/enums/origem.enum';

export default {
  props: new DialogProps(Organograma),
  mixins: [ManterOrganogramaService, ManterSetorService],
  data: () => ({
    form: {
      nome: "",
      sigla: "",
      listFuncoes: [],
      lists: {
        secretarias: [],
        setores: [],
      },
    },
  }),
  methods: {
    salvar() {
      const save = () => {
        const mensagemConfirmacao = this.edit
          ? "Confirma a edição do Organograma?"
          : "Confirma o cadastro do Organograma?";
        return this.$swal({
          text: mensagemConfirmacao,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          let payload = new Organograma(this.content);
          payload.setores = this.content.setores.map(setor => setor.id);
          return this.edit
            ? this.$editarOrganograma(payload, payload.id)
            : this.$cadastrarOrganograma(payload);
        });
      };

      if (this.$validarFormulario("Preencha os campos obrigatórios!")) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    buscarSecretariasExecutivas() {
      this.$obterSecretariasExecutivas().then(({ data }) =>
        this.form.lists.secretarias = data.itens.map((item) => ({ identificador: item.identificador, nome: item.nome })));
    },
    buscarSetores() {
      this.$buscarSetores({ params: { origem: OrigemEnum.SEE } }).then(({ data }) => this.form.lists.setores = data.itens);
    },
  },
  mounted() {
    this.buscarSetores();
    this.buscarSecretariasExecutivas();
  },
};
</script>
